import DoGuide from './DoGuide';
import * as DesignerFunctions from '../utilities/DesignerFunctions';
import * as ResponsiveFns from '../utilities/ResponsiveFns';
import * as CoreFns from '../utilities/CoreFns';
import * as EditorFunctions from '../utilities/EditorFunctions';
import * as Teleport from '../utilities/Teleport';
import { Icon } from '@iconify/react';
import {useState} from 'react';

function App(props) {

  var currentList = props.currentList;
  var error = props.error;
  var itemEdited = props.itemEdited;
  var setItemEdited = props.setItemEdited;
  var setIsShowingSomeDropDown = props.setIsShowingSomeDropDown;
  var userNos = props.userNos;
  var organicChanges = props.organicChanges;
  var highlightAnItem = props.highlightAnItem;
  var screenRefs = props.screenRefs;
  var leftColRefs = props.leftColRefs
  var flashHighlight = props.flashHighlight;
  var setFlashHighlight = props.setFlashHighlight;
  var addToExtraScreen = props.addToExtraScreen;
  var centerZoom = props.centerZoom;
  var fakeInternalVariables = props.fakeInternalVariables;
  var chains = props.chains;
  var changeTab = props.changeTab;

  const [hidden, setHidden] = useState({});
  // const [pathOfItemDraggedOver, setPathOfItemDraggedOver] = useState(false);
  const [draggingWhat, setDraggingWhat] = useState(false);

  function doItems1(thisObject, keys, feOrPUSet, path, itemType, specialInstructions, isAlert){
    return keys.map((aKey, index2)=>{
      var thisAlert = thisObject[aKey];
      var baseName = '';
      if (!isAlert){
        baseName = DesignerFunctions.getBaseTitle(thisAlert) + ' ';
        if (specialInstructions === 'HeaderTable' && +index2 === 0){
          baseName = 'Header Row ';
        }
      }else{
        baseName = 'Banner ';
      }

      var alertName = thisAlert._na;
      if (!alertName){
        alertName = '-';
      }
      var i = [];
      var items = null;
      var itemKey;
      var itemInfo;
      if (isAlert){
        items = thisAlert.k;
        itemKey = 'k';
        itemInfo = CoreFns.getElementInfo('ALERT');
      }else if (CoreFns.isHolder(thisAlert.t)){
        items = thisAlert.i;
        itemKey = 'i';
        itemInfo = CoreFns.getElementInfo(thisAlert.t);
      }

      if (items){
        var ic = itemInfo.i;
        var itemKeys = ResponsiveFns.sortAListBasedOnOrd(items);
        var specInstructions = false;
        if (thisAlert.t === 'TABLE'){
          if (thisAlert.s && thisAlert.s.firstRowHeader && thisAlert.s.firstRowHeader.v){
            specInstructions = 'HeaderTable';
          }
        }
        var i2 = doItems1(items, itemKeys, feOrPUSet, path.concat([aKey, itemKey]), 'item', specInstructions, false);
        var canTake = 'rel';
        var n = 'Card Items';
        if (itemType === 'alert'){
          n = 'Contents';
        }else if (thisAlert.t === 'HFLEX'){
          n = 'Row Items';
        }else if (thisAlert.t === 'CONTAINER'){
          n = 'Rows';
          canTake = 'HFLEX';
        }else if (thisAlert.t === 'TABLE'){
          n = 'Table Rows';
          canTake = 'TR';
        }else if (thisAlert.t === 'TR'){
          n = 'Table Cells';
          canTake = 'TD';
        }else if (thisAlert.t === 'TD'){
          n = 'Cell Items';
        }else if (thisAlert.t === 'TABS'){
          n = 'Tabs';
          canTake = 'TABITEM';
        }else if (thisAlert.t === 'TABITEM'){
          n = 'Tab Elements';
        }else if (thisAlert.t === 'SUMMARY'){
          n = 'Summary Items';
          canTake = 'SUMMARYDIV';
        }else if (thisAlert.t === 'TABITEM'){
          n = 'Tab Elements';
        }else if (thisAlert.t === 'navDropDown'){
          n = 'Dropdown Elements';
        }else if (thisAlert.t === 'GALLERY'){
          n = 'Gallery Elements';
          canTake = 'GALLERYITEM'
        }
        i = [{n, i:i2, path:path.concat([aKey, itemKey]), ic:'cil:sitemap', canTake, feOrPUSet}]
      }
      return {n:baseName + alertName, i, t:(isAlert ? 'alert' : 'item'), path:path.concat([aKey]), ic};
    })
  }

  var dragType = '';
  if (draggingWhat){
    dragType = itemDraggedType(draggingWhat.path);
  }

  function doFEOrPU(feOrPU, title, icSet){
    var frontEnds = currentList[feOrPU];
    var frontItems = [];
    if (frontEnds){
      var frontEndKeys = Object.keys(frontEnds);
      frontItems = frontEndKeys.map((aFrontEnd, index0)=>{

        var thisScreen = frontEnds[aFrontEnd];
        var nv = thisScreen.nv;
        var panels = thisScreen._s;
        var panelKeys = ResponsiveFns.sortAListBasedOnOrdNotStyle(panels);

        var toplineItems = [];
        if (nv.on){
          var navPath;
          var toDo = true;
          if (nv.on === 1){
            navPath = [feOrPU, aFrontEnd, 'nv'];
          }else{
            navPath = ['cn', nv.on, 'nv'];
            try{
              nv = CoreFns.goDownPath(currentList, navPath);
              if (nv.on){
                toDo = false;
              }
            }catch(err){
              toDo = false;
            }
          }

          if (toDo){
            var navI = [];
            var leftTitle = 'Items';
            if (nv.s.navbarCluster){
              leftTitle = 'Left';
            }
            var feOrPUSet = {t:feOrPU, v:aFrontEnd};
            var leftItems = nv.i;
            var leffItemKeys = ResponsiveFns.sortAListBasedOnOrd(leftItems);
            var leftInsides = doItems1(leftItems, leffItemKeys, feOrPUSet, navPath.concat(['i']), 'item', false, false);
            navI.push({n:leftTitle, i:leftInsides, path:navPath.concat(['i']), ic:'cil:sitemap', canTake:'nav'});
            if (nv.s.navbarCluster){
              var centerItems = nv.ic;
              var centerItemKeys = ResponsiveFns.sortAListBasedOnOrd(centerItems);
              var centerInsides = doItems1(centerItems, centerItemKeys, feOrPUSet, navPath.concat(['ic']), 'item', false, false);
              navI.push({n:'Center', i:centerInsides, path:navPath.concat(['ic']), ic:'cil:sitemap', canTake:'nav'});

              var rightItems = nv.ir;
              var rightItemKeys = ResponsiveFns.sortAListBasedOnOrd(rightItems);
              var rightInsides = doItems1(rightItems, rightItemKeys, feOrPUSet, navPath.concat(['ir']), 'item', false, false);
              navI.push({n:'Right', i:rightInsides, path:navPath.concat(['ir']), ic:'cil:sitemap', canTake:'nav'});

            }

            toplineItems.push({n:'Navigation Bar', t:'navBar', i:navI, path:navPath, ic:'fluent:navigation-16-filled'});
            
          }
        }

        var panelBranches = panelKeys.map((aPanelKey, index)=>{
          var thisPanel = panels[aPanelKey];
          var panelPath = [feOrPU, aFrontEnd, '_s', aPanelKey];
          var alerts = thisPanel.al;
          var absolutes = thisPanel.i;
          var relatives = thisPanel.k;

          var panelInsides = [];

          var alertKeys = ResponsiveFns.sortAListBasedOnOrd(alerts);
          if (alertKeys.length > 0 || (draggingWhat && draggingWhat.path[4] === 'al')){
            var alertInsides = doItems1(alerts, alertKeys, null, panelPath.concat(['al']), 'item', false, true);
             panelInsides.push({n:'Banners', i:alertInsides, path:panelPath.concat(['al']), ic:'cil:sitemap', canTake:'alert'});
          }

          if (!relatives){
            setTimeout(function(){ 
              organicChanges([{t:'w',w:panelPath.concat(['k']), n:{}}])

            }, 1);
          }
          var relativeKeys = ResponsiveFns.sortAListBasedOnOrd(relatives);
          if (relativeKeys.length > 0 || (draggingWhat && draggingWhat.path[4] === 'k')){
            var relativeInsides = doItems1(relatives, relativeKeys, null, panelPath.concat(['k']), 'item', false, false);
            panelInsides.push({n:'Relative Elements', i:relativeInsides, path:panelPath.concat(['k']), ic:'cil:sitemap', canTake:'rel'})
          }

          var absoluteKeys = Object.keys(absolutes);
          if (absoluteKeys.length > 0 || (draggingWhat && draggingWhat.path[4] === 'i')){
            var absoluteInsides = doItems1(absolutes, absoluteKeys, null, panelPath.concat(['i']), 'item', false, false);
            panelInsides.push({n:'Absolute Elements', i:absoluteInsides, path:panelPath.concat(['i']), ic:'cil:sitemap', canTake:'abs'});
          }

          return {n:thisPanel._na, i:panelInsides, path:panelPath, t:'screen', ic:'carbon:open-panel-bottom'};
        })

        toplineItems.push({n:'Panels', i:panelBranches, path:[feOrPU, aFrontEnd, '_s'], ic:'cil:sitemap', canTake:'panel'});

        return {n:thisScreen.n, i:toplineItems, path:[feOrPU, aFrontEnd], t:'page', ic:icSet};

      });

    }

    return {n:title, i:frontItems, path:[feOrPU], ic:'bi:collection', canTake:'none'}; 
  }

  var frontEndTree = doFEOrPU('fe', 'Front Ends', 'bi:display');
  var popUpTree = doFEOrPU('pu', 'Pop Ups', 'carbon:popup');


  var secondTree;
  if (currentList.fo && currentList.fo.on){
    var footerItems = currentList.fo.k;
    var footerKeys = Object.keys(footerItems);
    var footerInsides = doItems1(footerItems, footerKeys, null, ['fo', 'k'], 'item', false, false);
    var ele = {n:'Footer Elements', i:footerInsides, path:['fo', 'k'], ic:'cil:sitemap', canTake:'rel'};
    secondTree = outputTree({n:'Footer', i:[ele], path:['fo'], t:'screen', ic:'fluent:document-footer-16-regular'})
  }

  var errorScreenPath = '';
  if (error && error.screenPath){
    errorScreenPath = error.screenPath.join(' ');
  }
  
  function dropHere(path){
    return function(e){
      var pieceToMove = CoreFns.goDownPath(currentList, draggingWhat.path);
      var pieceToMoveNew = JSON.parse(JSON.stringify(pieceToMove));

      var changes = [];

      var newPath = [];
      if (!draggingWhat){
        return;
      }
      var panelPath = [];

      if (dragType === 'panel'){
        panelPath = CoreFns.filterPathStopBefore(path, 3);
        var panels = CoreFns.goDownPath(currentList, panelPath);
        var panelKeys = Object.keys(panels);
        if (path.length === 3){
          pieceToMoveNew.ord = 0;
          panelKeys.forEach((aPanelKey, index)=>{
            var thisPanel = panels[aPanelKey];
            changes.push({t:'w',w:path.concat([aPanelKey, 'ord']), n:thisPanel.ord + 1});
          })
        }else{
          var relevantPanel = panels[path[3]];
          var relOrd = relevantPanel.ord;
          pieceToMoveNew.ord = relOrd + 1;
          panelKeys.forEach((aPanelKey, index)=>{
            var thisPanel = panels[aPanelKey];
            if (thisPanel.ord >= relOrd){
              changes.push({t:'w',w:path.concat([aPanelKey, 'ord']), n:thisPanel.ord + 1});
            }
          })

        }

      }else if (dragType === 'abs'){
        panelPath = CoreFns.filterPathStopBefore(path, 5);
      }else{
        if (isHolder(path)){
          panelPath = path;
          var items = CoreFns.goDownPath(currentList, panelPath);
          var itemKeys = Object.keys(items);
          itemKeys.forEach((anItemKey, index)=>{
            var thisItem = items[anItemKey];
            changes.push({t:'w',w:path.concat([anItemKey, 's', 'ord', 'v']), n:thisItem.s.ord.v + 1});
          })
          pieceToMoveNew.s.ord.v = 0;

        }else{
          panelPath = CoreFns.filterPathStopBefore(path, path.length - 1);
          var relOrd2 = CoreFns.goDownPath(currentList, path).s.ord.v + 1;
          pieceToMoveNew.s.ord.v = relOrd2;
          var items1 = CoreFns.goDownPath(currentList, panelPath);
          Object.keys(items1).forEach((anItemKey, index)=>{
            var thisItem = items1[anItemKey];
            if (thisItem.s.ord.v >= relOrd2){
              changes.push({t:'w',w:panelPath.concat([anItemKey, 's', 'ord', 'v']), n:thisItem.s.ord.v + 1});
            }
          })
        }
      }

      var uuid = CoreFns.uuidCheckEverywhere(userNos, currentList); 
      newPath = panelPath.concat([uuid]);

      changes.push({t:'w',w:newPath,n:pieceToMoveNew});
      var addChanges = EditorFunctions.doAddChanges(currentList, draggingWhat.path, newPath, chains, changeTab); 
      changes = changes.concat(addChanges);

      changes.push({t:'r', w:CoreFns.filterPathStopBefore(draggingWhat.path, draggingWhat.path.length - 1),i:draggingWhat.path[draggingWhat.path.length - 1]});

      organicChanges(changes);
      setDraggingWhat(false);
      setItemEdited({t:draggingWhat.t, path:newPath});
      e.stopPropagation();
    }
  }

  function getParentalHostPath(path){ //ie this should include the i.
    if (isFEorPU(path)){
      if (path.length % 2 === 0){
        return CoreFns.filterPathStopBefore(path, path.length - 1);
      }else{
        return path;
      }
    }else if (path[0] === 'fo'){
      if (path.length % 2 === 1){
        return CoreFns.filterPathStopBefore(path, path.length - 1);
      }else{
        return path;
      }
    }

  }

  function determineDragTypeBaedOnPath(path){
    var draggedType1 = CoreFns.goDownPath(currentList, path).t;
    if (draggedType1 === 'HFLEX' || draggedType1 === 'TR' || draggedType1 === 'TD' || draggedType1 === 'TABITEM' || draggedType1 === 'GALLERYITEM'){
      return draggedType1;
    }else{
      return 'rel';
    }
  }

  function isFEorPU(path){
    return (path[0] === 'fe' || path[0] === 'pu');
  }

  function itemDraggedType(path){
    if (isFEorPU(path) && path[2] === '_s'){
      if (path.length === 4){
        return 'panel';
      }else if (path[4] === 'k'){
        return determineDragTypeBaedOnPath(path);
      }else if (path.length > 6){
        return determineDragTypeBaedOnPath(path);
      }else if (path[4] === 'i'){
        return 'abs';
      }else if (path[4] === 'al'){
        return 'alert';
      }
    }else if (isFEorPU(path) && path[2] === 'nv'){
      return 'nav';
    }else if (path[0] === 'fo'){
      if (path[1] === 'k'){
        return 'rel';
      }else if (path.length > 3){
        return determineDragTypeBaedOnPath(path);
      }else if (path[1] === 'i'){
        return 'abs';
      }else if (path[1] === 'al'){
        return 'alert';
      }
    }
    return '';
  }

  function determineParentalAcceptanceBasedOnPath(path){
    var parentalType = getParentalType(path);
    if (parentalType === 'CONTAINER'){
      return 'HFLEX'
    }else if (parentalType === 'TABS'){
      return 'TABITEM'
    }else if (parentalType === 'TABLE'){
      return 'TR'
    }else if (parentalType === 'TR'){
      return 'TD'
    }else if (parentalType === 'GALLERY'){
      return 'GALLERYITEM'
    }else{
      return 'rel';
    }
  }

  function holderType(path){
    if (isFEorPU(path) && path[2] === '_s'){
      if (path.length < 5){
        return 'panel';
      }else if (path[4] === 'k' && path.length <= 6){
        return 'rel';
      }else if (path.length > 6){
        return determineParentalAcceptanceBasedOnPath(path);
      }else if (path[4] === 'i'){
        return 'abs';
      }else if (path[4] === 'al'){
        return 'alert';
      }
    }else if (isFEorPU(path) && path[2] === 'nv' && path.length > 3){
      return 'nav';
    }else if (path[0] === 'fo'){
      if (path[1] === 'k' && path.length <= 3){
        return 'rel';
      }else if (path.length > 3){
        return determineParentalAcceptanceBasedOnPath(path);
      }else if (path[1] === 'i'){
        return 'abs';
      }else if (path[1] === 'al'){
        return 'alert';
      }
    }
    return '';      
  }

  function getParentalType(path){
    var pathBack = getParentalHostPath(path);
    var item = CoreFns.goDownPath(currentList, pathBack, 1);
    return item.t;
  }

  function onClick(aRow){
    return function(e){
      if (aRow.t){
        var changeTab = function(x){}
        Teleport.goToLocation(aRow.path, aRow.path, aRow.feOrPUSet, changeTab, setIsShowingSomeDropDown, setItemEdited, screenRefs, leftColRefs, flashHighlight, setFlashHighlight, 'blue', currentList, centerZoom, fakeInternalVariables);
      }
    }
  }

  function setDragOver(path){
    return function(e){
      // setPathOfItemDraggedOver(path);
      e.stopPropagation();
      e.preventDefault();
    }
  }
    function collapseTree(path){
      return function(e){
        var pathString = path.join(' ');
        if (hidden[pathString]){
          delete hidden[pathString];
        }else{
          hidden[pathString] = true;
        }
        setHidden({...hidden});
      }
    };

    function dragEndReal(e){
      setDraggingWhat(false);
      // setPathOfItemDraggedOver(false);
      e.stopPropagation();
    }

    function dragStart(item){
      return function(e){
        setDraggingWhat(item);
        e.stopPropagation();
      }
    }

    function isHolder(path){
      if (path[0] === 'fo'){
        return (path.length % 2 === 0)
      }else if (isFEorPU(path)){
        if (path[2] === '_s'){
          return (path.length % 2 === 1);
        }else if (path[2] === 'nv'){
          return (path.length % 2 === 0)
        }
      }
    }


    function outputTree(item){

        var icon = item.ic;
        var className = "navigatorTreeTitle";

        var aStyle = {}
        if (!item.t){
          aStyle.cursor = 'default';
        }

        if (highlightAnItem && highlightAnItem.t === 'navigator' && highlightAnItem.v === item.t){
          aStyle.color = 'blue';
        }
        var namePieceStyle = {};
        var pathString = item.path.join(' ');
        if (itemEdited){
          if (pathString === itemEdited.path.join(' ')){
            namePieceStyle.fontWeight = 'bold';
            namePieceStyle.backgroundColor = 'black';
            namePieceStyle.padding = '3px'
          }
        }
        var namePiece = <span style={namePieceStyle}>{item.n}</span>
//
        var putItemHere = null;
        var putItemHereBottom = null;
        if (draggingWhat){
          var bbColor = '#888888';

          var itemOrHolderType = holderType(item.path);
          if (dragType === itemOrHolderType){
            if (item.path.join(' ').indexOf(draggingWhat.path.join(' ')) === -1){
              var onDragOver = setDragOver(item.path);
              var onDrop = dropHere(item.path);
              var onDragLeave = setDragOver(false);              

              if (isHolder(item.path)){
                putItemHere = <div className='navigatorTreeTitle'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style={{padding:'3px', backgroundColor:bbColor}} onDragOver={onDragOver} onDragLeave={onDragLeave} onDrop={onDrop}><Icon icon='pixelarticons:drop-area'/>&nbsp;&nbsp;Move Item Here</span></div>
              }else{
                putItemHereBottom = <div className='navigatorTreeTitle'>&nbsp;&nbsp;&nbsp;<span style={{padding:'3px', backgroundColor:bbColor}} onDragOver={onDragOver} onDragLeave={onDragLeave} onDrop={onDrop}><Icon icon='pixelarticons:drop-area'/>&nbsp;&nbsp;Move Item Here</span></div>
              }
            }              
          }


                  
        }
        var draggable = true;
        if (isHolder(item.path)){
          draggable = false;
          aStyle.color = '#A2A2A2';
        }else if (isFEorPU(item.path) && item.path[2] === '_s' && item.path.length === 2){
          draggable = false;
        }


        var onDragEnd = function(e){}
        var onDragStart = function(e){}
        if (draggable){
          onDragStart = dragStart(item);
          onDragEnd = dragEndReal;
        }

//
        if (item.i.length!==0) {
            var subList = [];
            var arrowClassName = "arrowPad"
            if (hidden[pathString]){
              if (errorScreenPath.indexOf(pathString) === 0){
                className += " navigatorTreeTitleRed";              
              }
                arrowClassName += " rotate";
                subList = ""
            }else{
              if (errorScreenPath === pathString){
                className += ' navigatorTreeTitleRed';   
              }else if (dragType === item.canTake){
                aStyle.color = 'yellow';
              }
              for (var i = 0; i < item.i.length; i++) {
                  subList.push(outputTree(item.i[i]))
              }              
            }
            return <div className="navigatorTree is-expandable" draggable={draggable} onDrag={onDragStart} onDragEnd={onDragEnd} >
                        <div> 
                            <span className={arrowClassName} onClick={collapseTree(item.path)}>></span>
                            <span className={className} onClick={onClick(item)} style={aStyle}><Icon icon={icon} />&nbsp; {namePiece} </span>
                            {putItemHere}
                            </div>
                        {subList}
                        {putItemHereBottom}
                    </div>
//
        } else {
            className += " navigatorTreeEnd";
            if (errorScreenPath === pathString){
              className += ' navigatorTreeTitleRed';              
            }else if (dragType === item.canTake){
              aStyle.color = 'yellow';
            }
            return <div className="navigatorTree " draggable={draggable} onDrag={onDragStart} onDragEnd={onDragEnd} onDragOver={onDragOver}  onDragLeave={onDragLeave} onDrop={onDrop}>
                  <div>
                    <span className='arrowPad rotate' >&nbsp;-</span>
                    <span className={className} onClick={onClick(item)} style={aStyle}><Icon icon={icon} /> &nbsp; {namePiece}</span>
                    {putItemHere}
                    </div>
                    {putItemHereBottom}
                </div>
//
        }
    };

    var msg;
    if (!dragType){
      msg = '';
    }else if (dragType === 'panel'){
      msg = 'Drop panel under a panels branch';
    }else if (dragType === 'HFLEX'){
      msg = 'Drop row under a container';
    }else if (dragType === 'TR'){
      msg = 'Drop table row under a table';
    }else if (dragType === 'TD'){
      msg = 'Drop table cell under a table row';
    }else if (dragType === 'rel'){
      msg = 'Drop item under a relative elements branch';
    }else if (dragType === 'abs'){
      msg = 'Drop item under an absolute elements branch';
    }else if (dragType === 'alert'){
      msg = 'Drop alert under an alerts branch';
    }else if (dragType === 'nav'){
      msg = 'Drop navigation item under a navigation bar';
    }



   return <div className='container' style={{textAlign:'left'}}><br/>
            <DoGuide addToExtraScreen={addToExtraScreen} set={{t:'tabNavigator'}} />
            <center><p className='lead mb-0 explanation'>{msg}</p></center><br/>
            {outputTree(frontEndTree)}
            {secondTree}
            {outputTree(popUpTree)}
      </div>
  

}

export default App;
